<template>
  <div>
    <div class="yl-c" style="width:1220px;margin:0 auto;height:auto;overflow:hidden;margin-top:3px;background-color:white;border:1px solid white">
    	<div style="" class="kk-title" style="background-color:white;">
    		<div style=" text-align:center;" class="kk-title-text">友情链接</div><a href="#"
    			class="kk-title-more">更多&gt;&gt;</a>
    		<div class="clear"></div>
    	</div>
    	<div class="yl-list" style="background-color:white;"><a href="https://www.bjraee.com/index/" target="_blank" class="partnerUrl"><img
    				src="../../assets/link/beijinglogo.jpeg"></a><a
    			href="https://www.cdaee.com/" target="_blank" class="partnerUrl"><img
    				src="../../assets/link/chengdu.jpg"></a><a
    			href="http://www.gzaee.com.cn/" target="_blank" class="partnerUrl"><img
    				src="../../assets/link/guangzhou.jpg"></a><a
    			href="http://www.tjnjs.com/#/home/home" target="_blank" class="partnerUrl"><img
    				src="../../assets/link/tianjin.jpg"></a>

            <a
            href="http://www.zwdit.com/" target="_blank" class="partnerUrl" style="background-color:#fefcfe;line-height:48px;">
            <div style="width: 30%;float:left">
              <img src="../../assets/link/link10.png">
            </div>
            <div style="width:60%;float:left">中微达科技有限公司</div>
            </a>

    		<div class="clear"></div>
    	</div>
    </div>


    <div class="footer-c" >
    	<div class="footer-container" style="font-size: 18px;">
    		<p style="white-space: normal; text-align: center;">
    			<span class="footer-container-right" style="color:black;font-weight: 800;font-size: 16px;">
             <span v-if="unitCode=='410825000000'">温县产权交易中心版权所有</span>
<span v-if="unitCode=='410800000000'">焦作市产权交易中心版权所有</span>
             Copyright © 2024 All Right
    				Reserved</span><br>
    		</p>

        <p style="white-space: normal; text-align: center;">
        	<span class="footer-container-right" style="color:black;font-weight: 800;font-size: 16px;">

            <span>
               地址：{{ unitInfo.address }}
            </span> 
            <span>
              电话：{{ unitInfo.phone }}
            </span> 

        &nbsp;
      
        </span>
        </p>
        <p style="white-space: normal; text-align: center;">
          <a href="http://www.zwdit.com" target="_blank">
        	<span class="footer-container-right" style="color:black;font-weight: 800;font-size: 16px;">
           中微达科技有限公司运营和技术支持</span>
           </a>
        </p>


<!--    		<p style="white-space: normal; text-align: center;">
    			<span style="color:#666666;font-family:微软雅黑">
    				<span style="font-size: 12px;"><a href="http://www.miitbeian.gov.cn"
    						target="_blank" style="color:black;font-weight: 800;">豫ICP备2022008469号-1</a><span style="">&nbsp;
    						&nbsp; &nbsp; &nbsp; &nbsp;</span></span></span>
    		</p> -->
    		<p style="text-align: center; margin-top: 10px;color:black;font-weight: 800;"><img
    				src="http://repo.sztdcqjy.com:80/pool/protected/local/image/portal/82Evc0_i_uPLAa98eplL0LYyDzKzVp3Y.png">&nbsp;豫ICP备2023036971号-1 &nbsp;&nbsp;豫公网安备41010702003385号</p>

    	</div>
    </div>
  </div>
</template>

<script>
    export default {
      data() {
      return {
        unitCode: localStorage.getItem("unitCode"),
        isRouterAlive: true,
        unitInfo:{},

      }
    },
    mounted(){
      this.getUnitInfo();
    },
    methods:{
      async getUnitInfo(){
      const action = "/web/unitCode/getByUnitCode/" +localStorage.getItem("unitCode");
      const {
        data: res
      } = await this.$http.get(action);
      this.unitInfo = res.data;
    },
    }}
</script>


<style>
  @import url("../../assets/css/index.css");
  @import url("../../assets/css/base.css");
  @import url("../../assets/css/main.css");
  @import url("../../assets/css/news.css");

  .iconlist {
    animation: rolling 18s linear infinite;
    position: absolute;
    display: flex;
  }


  @keyframes rolling {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-50%);
    }
  }
  li{  cursor: pointer;}

  .news {
    float: left;
    width: 110px;
    text-align: center;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
  }

  .newsHeader {
    height: 320px;
    border: 1px solid #efefef;
    margin-left: 15px;
  }

  .activeSelect {
    background-color: #4cb050;
    color: white;
  }

  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 2px;
  }
</style>
